export default __webpack_public_path__ + "static/media/plus.33c085dd.svg";